import script from "./patient-details.vue?vue&type=script&setup=true&lang=js"
export * from "./patient-details.vue?vue&type=script&setup=true&lang=js"

import "./patient-details.vue?vue&type=style&index=0&id=5daa5206&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5daa5206"]])

export default __exports__